(function() {
'use strict';

angular
    .module('dashboard')
    .factory('onlineCheckinService', onlineCheckinService);

function onlineCheckinService(
    $http,
    $filter,
    resourceService) {
    const checkinURL = '/api2/flightscheckin';
    const service = {
        getOnlineCheckinOptions,
        doCheckin,
        getCheckinAvailability,
        getCheckinType,
        addCheckinData
    };

    const flightClass = {
        1: resourceService.getDeferred('ECONOMYCLASS'),
        2: resourceService.getDeferred('PREMIUMECONOMYCLASS'),
        4: resourceService.getDeferred('FIRSTCLASS'),
        8: resourceService.getDeferred('BUSINESSCLASS')
    };
    const checkinType = {
        Unknown: { label: resourceService.getDeferred('ONLINECHECKIN_CHECKINSTATUSUNKNOWN'), isEnabled: false, isSupported: false, isCheckedIn: false, apiRequired: false },
        NotSupported: { label: resourceService.getDeferred('ONLINECHECKIN_ONLINECHECKINNOTSUPPORTED'), isEnabled: false, isSupported: false, isCheckedIn: false, apiRequired: false },
        Available: { label: resourceService.getDeferred('ONLINECHECKIN_CANCHECKIN'), isEnabled: true, isSupported: true, isCheckedIn: false, apiRequired: false },
        CheckedIn: { label: resourceService.getDeferred('ONLINECHECKIN_ALREADYCHECKEDIN'), isEnabled: false, isSupported: false, isCheckedIn: true, apiRequired: false },
        ApiRequired: { label: resourceService.getDeferred('ONLINECHECKIN_PENDINGPASSENGERDETAILS'), isEnabled: false, isSupported: true, isCheckedIn: false, apiRequired: true },
        Closed: { label: resourceService.getDeferred('ONLINECHECKIN_CHECKINCLOSED'), isEnabled: false, isSupported: false, isCheckedIn: false, apiRequired: false },
        WaitingToOpen: { label: resourceService.getDeferred('ONLINECHECKIN_NOTINCHECKINWINDOW'), isEnabled: false, isSupported: true, isCheckedIn: false, apiRequired: false }
    };

    function getOnlineCheckinOptions(bookingId) {
        return $http.post(`${checkinURL}/options`, bookingId).then(function(result) {
            angular.forEach(result.data.Legs, function(leg) {
                getCheckinType(leg);
                leg.flightClass = flightClass[leg.FlightClass];
                angular.forEach(leg.Passengers, function(passenger) {
                    passenger.passengerType = resourceService.get(passenger.Type);
                });
            });
            return result.data;
        });
    }


    function doCheckin(bookingId, legs) {
        return $http.post(`${checkinURL}/checkin`, { BookingId: bookingId, Legs: legs }).then(function(response) {
            return response.data;
        });
    }

    function getCheckinAvailability(bookingIds) {
        return $http.post(`${checkinURL}/availability`, { BookingIds: bookingIds }, { ignoreErrors: true }).then(function(result) {
            const data = result.data;
            angular.forEach(data, function(legs, bookingId) {
                const checkinData = {};
                let startTime;
                angular.forEach(legs, function(leg) {
                    const isLegEarlier = (leg && (leg.CheckinStartTime < startTime)) || !startTime;
                    startTime = leg && isLegEarlier ? leg.CheckinStartTime : startTime;
                });
                checkinData.checkinDisabled = !(startTime && (new Date() > new Date(startTime)));
                checkinData.checkinMessage = !checkinData.checkinDisabled ? resourceService.get('ONLINECHECKIN_CHECKINENABLED') : String.format(resourceService.get('ONLINECHECKIN_CHECKINSTARTFROM'), $filter('date')(startTime, 'dd MMM yyyy'), $filter('date')(startTime, 'HH:mm'));
                data[bookingId] = checkinData;
            });
            return data;
        });
    }

    function getCheckinType(leg) {
        leg.checkinType = checkinType[leg.CheckinState] ? checkinType[leg.CheckinState] : checkinType.Unknown;
    }

    function addCheckinData(trips) {
        const bookingIds = [];
        angular.forEach(trips, function(trip) {
            const booking = _.find(trip.Bookings, bk => bk.Status !== 2 && bk.DoesSupportOnlineCheckin);
            if (booking) {
                bookingIds.push(booking.BookingId);
            }
        });

        if (bookingIds.length > 0) {
            getCheckinAvailability(bookingIds).then(function(checkinData) {
                angular.forEach(trips, function(trip) {
                    angular.forEach(trip.Bookings, function(bk) {
                        if (checkinData[bk.BookingId]) {
                            const checkinAction = _.find(bk.BookingOptions.Actions, function(action) {
                                return action.Name === 'ONLINECHECKIN';
                            });
                            if (checkinAction) {
                                checkinAction.disabled = checkinData[bk.BookingId].checkinDisabled;
                                checkinAction.disabledInfo = checkinData[bk.BookingId].checkinMessage;
                            }
                        }
                    });
                });
            });
        }
    }

    return service;
}
})();
